/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroupTypeEnum,
    DisciplineGroupTypeEnumFromJSON,
    DisciplineGroupTypeEnumFromJSONTyped,
    DisciplineGroupTypeEnumToJSON,
} from './DisciplineGroupTypeEnum';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';

/**
 * 
 * @export
 * @interface AddDisciplineGroupDTO
 */
export interface AddDisciplineGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof AddDisciplineGroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {DisciplineGroupTypeEnum}
     * @memberof AddDisciplineGroupDTO
     */
    type?: DisciplineGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AddDisciplineGroupDTO
     */
    disiplineCount?: number;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof AddDisciplineGroupDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof AddDisciplineGroupDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {string}
     * @memberof AddDisciplineGroupDTO
     */
    studyPlanId?: string;
}

export function AddDisciplineGroupDTOFromJSON(json: any): AddDisciplineGroupDTO {
    return AddDisciplineGroupDTOFromJSONTyped(json, false);
}

export function AddDisciplineGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDisciplineGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : DisciplineGroupTypeEnumFromJSON(json['type']),
        'disiplineCount': !exists(json, 'disiplineCount') ? undefined : json['disiplineCount'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
    };
}

export function AddDisciplineGroupDTOToJSON(value?: AddDisciplineGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': DisciplineGroupTypeEnumToJSON(value.type),
        'disiplineCount': value.disiplineCount,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'studyPlanId': value.studyPlanId,
    };
}

